import { useMutation } from '@tanstack/react-query';
import { createSubTask, CreateSubTaskInput } from 'shared/services/backend-api';

export const useCreateSubTaskMutation = () =>
  useMutation({
    mutationFn: (input: CreateSubTaskInput) => createSubTask(input),
  });
